//import logo from "./logo.svg";
import { BrowserRouter } from "react-router-dom";
import Routing from "./Routes/routers";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { UserProvider } from "./userContext";
import NoInternet from "./NoInternet";
import { useSelector } from "react-redux";
const  NotificationBell =  lazy(() => import("./Components/View/Notifications/NotificationBell"));
const ChatWidget = lazy(() => import("./paupet/Support/SupportChat"));
 



function App() {
  const auth = useSelector((state) => state.authentication);
  const { userData, branchData, branch } = auth;

  const userRightsTemp = sessionStorage.getItem("rights");

  let userRightsSession = null;
  if (userRightsTemp !== "undefined") {
    try {
      userRightsSession =
        sessionStorage.getItem("rights") &&
        JSON.parse(sessionStorage.getItem("rights"));
    } catch (error) {
      console.error("Error parsing rights:", error);
    }
  }

  const [userRights, setUserRights] = useState(userRightsSession);

  useEffect(() => {
    if (userData.token && userData.branch === "CLT") {
      const favicon = document.getElementById("favicon");
      if (favicon) {
        favicon.href = "/favicon_cutis.ico?v=2";
      }
      document.title = "Cutis International";
    }
  }, [userData]);

  return (
    <BrowserRouter>
      <UserProvider>
        {/* Always render NoInternet banner (it handles its own visibility internally) */}
        <NoInternet />
        
        {/* Always render Routing so your pages and UI never disappear */}
        <Routing userRights={userRights} setUserRights={setUserRights} />
      </UserProvider>

      <Suspense fallback={<div>Loading chat...</div>}>
        <NotificationBell userData={userData} branchData={branchData} branch={branch} />
        <ChatWidget />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;